import angular from "angular";

angular
    .module('app')
    .component('loginForm', {
        template: require('./login-form.html'),
        controller: ['$http', '$document', '$timeout', '$interval', 'Notifier', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&',
        }
    });

function controller($http, $document, $timeout, $interval, Notifier) {

    let $ctrl = this;

    $ctrl.phoneMasks = [
        {country: 'Kazakhstan', country_code: 'KZ', phone_code: '+7', phone_mask: '+7 (999) 999-99-99'},
        {country: 'Turkish', country_code: 'TR', phone_code: '+90', phone_mask: '+7 (999) 999-99-99'},
        {country: 'Russian', country_code: 'RU', phone_code: '+7', phone_mask: '+7 (999) 999-99-99'},
        {country: 'Usa', country_code: 'USA', phone_code: '+1', phone_mask: '+1 (999) 999-99-99'},
        {country: 'UAE', country_code: 'UAE', phone_code: '+971', phone_mask: '+\\971 (999) 99-9999'},
        {country: 'SPAIN', country_code: 'SPA', phone_code: '+34', phone_mask: '+34 (999) 999-999'}
    ];

    $ctrl.selectedMask = $ctrl.phoneMasks[0];

    $ctrl.phone = null;
    $ctrl.password = null;
    $ctrl.rememberMe = false;

    $ctrl.$onInit = function () {
        focusOnPhone();
    };

    function focusOnPhone() {
        $timeout(function () {
            $document[0].getElementById('phone-input').focus();
        }, 300);
    }

    $ctrl.maskChanged = function () {
        $ctrl.phone = null;
        focusOnPhone();
    };

    $ctrl.submit = function () {

        if ($ctrl.loading) {
            return;
        }

        $ctrl.loading = true;

        $ctrl.validationErrors = null;

        $http
            .post('/login', {
                phone: $ctrl.phone.replace(/\D/g, ''),
                password: $ctrl.password,
                remember: $ctrl.rememberMe
            })
            .then(
                function (response) {
                    $ctrl.loading = false;
                    $ctrl.close({$value: response.data});
                },
                function (error) {
                    $ctrl.loading = false;
                    if (error.status == 422 || error.status == 429) {
                        $ctrl.validationErrors = error.data.errors;
                    } else {
                        $ctrl.errorMessage = error.data.message;
                    }
                }
            );
    };

    $ctrl.dismissModal = function (command) {
        $ctrl.dismiss({$value: command});
    };
}
